// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3lnEK","quickShop":"styles_quickShop__nQ57n"};